export default "__VITE_ASSET__78386187__"